import globalConstant from 'constants/globalConstant';
import API_CONSTANT from 'constants/apiConstant';
import { put, takeEvery } from 'redux-saga/effects';
import { triggerRepaymentStatusApiCallSuccess } from 'redux/actions';
import { TRIGGER_REPAYMENT_STATUS_API_CALL } from 'redux/actionTypes';
import { apiCall } from 'services';
import {
	ChangeHistory,
	CleverTapEvent,
	CleverTapEventNames,
	history,
	isIOS,
	isWrouteValue,
	nativeHandler,
} from 'utils';

function* triggerRepaymentStatusApiCall(actions) {
	const { data, callback, stopLoader } = actions;
	const ORDER_ID = data['orderId'];
	const PATH = data['path'];
	yield put(triggerRepaymentStatusApiCallSuccess());
	const api = yield apiCall({
		urlType: API_CONSTANT.URL_TYPE.POST_PE,
		url: API_CONSTANT.URL.REPAYMENT_STATUS + API_CONSTANT.QUERY_PARAMS.ORDER_ID + ORDER_ID,
		method: 'GET',
		options: {
			defaultLoader: !stopLoader,
		},
		loaderDetails: {
			first_message: 'fetching transaction',
			start_index: 0,
			range: 8,
			second_message: 'details',
		},
	});
	if (api && api.data.data) {
		const apiData = api.data.data;
		if (apiData) {
			callback && callback(apiData);
			if (apiData?.paymentStatus !== 'CANCELLED') {
				localStorage.setItem('txn', 'true');
				if (apiData?.paymentStatus === 'SUCCESS') {
					CleverTapEvent.send(CleverTapEventNames.EVENTS_NAME.MANDATORY_EVENTS.TRANSACTION_SUCCESS, [
						`txnId: ${apiData?.txnId}`,
						`amount: ${apiData?.amount}`,
						`cashbackAmount: ${apiData?.cashbackAmount}`,
						`cashbackTier: ${apiData?.cashbackTier}`,
						`merchantName: ${apiData?.merchantName}`,
						`status: ${apiData?.paymentStatus}`,
						`txnMode: ${apiData?.txnMode}`,
						`txnSubType: ${apiData?.txnSubType}`,
						`txnTime: ${apiData?.txnTime}`,
						`af_revenue: ${apiData?.amount}`,
					]);
				}
				apiData['path'] = PATH;
				!stopLoader && history.push(`/transaction-status`);
				yield put(triggerRepaymentStatusApiCallSuccess(apiData));
			} else {
				if (isWrouteValue(globalConstant.WROUTE.TXN_STATUS)) {
					if (isIOS) {
						ChangeHistory('back', apiData?.paymentStatus === 'SUCCESS' ? '/postpaid/home' : '/postpaid/bill-view');
					} else {
						nativeHandler.refreshHome();
						nativeHandler.closeWebView();
					}
				}
			}
		}
	}
}

export default function* triggerRepaymentStatusApiCallSaga() {
	yield takeEvery(TRIGGER_REPAYMENT_STATUS_API_CALL, triggerRepaymentStatusApiCall);
}
